const ranks = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A'];
const suits = ['s', 'c', 'd', 'h'];
const rankNames = {
    '2': 'Two',
    '3': 'Trey',
    '4': 'Four',
    '5': 'Five',
    '6': 'Six',
    '7': 'Seven',
    '8': 'Eight',
    '9': 'Nine',
    'T': 'Ten',
    'J': 'Jack',
    'Q': 'Queen',
    'K': 'King',
    'A': 'Ace',
};

export class Card {
    constructor(rank, suit) {
        if(!ranks.includes(rank)) {
            throw Error('Invalid rank!');
        }
        if(!suits.includes(suit)) {
            throw Error('Invalid suit!');
        }
        this.rank = rank;
        this.suit = suit;
    }

    static getNameByRank(rank) {
        return rankNames[rank];
    }

}